module.exports = __webpack_public_path__ + "static/iski-2-b4ef20771240ebdf6c271a49cca642df.png";